import React, { Fragment, useRef, useEffect } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SaveIcon from "@material-ui/icons/Save";
import DoneAll from "@material-ui/icons/DoneAll";
import DeleteIcon from "@material-ui/icons/Delete";
import RefreshIcon from "@material-ui/icons/Refresh";
import download from "js-file-download";
import { usuarioNextSequence } from "../../services/UsuarioService";
import { sysparamFindBySysNome } from "../../services/SysparamService";

import {
    availableOperador,
    availableSupervisor,
    containerImagehighresolution,
    containerLowresolution,
    uploadSuspectImage,
    updateVereditoAprovado,
    updateVereditoInconsistente,
    updateVereditoSuspeito,
    vereditosAtribuidos,
    checkifexpired,
    sysdatetime,
    msgconsole,
} from "../../services/ContainerService";
import { Formik } from "formik";
import Switch from "@material-ui/core/Switch";

import { suspeitaTipoFindAll } from "../../services/SuspeitaTipoService";
import {
    suspeitaFindByConIdCovIdVeuId,
    suspeitaInsert,
    suspeitaDelete,
} from "../../services/SuspeitaService";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { DataGrid } from "@material-ui/data-grid";

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import { ButtonSave } from "../botoes/operacao";
import { ThemeProvider } from "@material-ui/core/styles";
import { ShowMessageBox } from "../ShowMessageBox";
import { Loading } from "../Loading";

import { useStyles } from "../styles/StyleAnalisar";
import { theme } from "../styles/Theme";

var canvas;
let severity = "error";
let msg = "";
var situacaoContainer;

/*

  +------------------------------------------------------------------------------------+
  |                                      Analisar                                      |
  +------------------------------------------------------------------------------------+

*/

export default function Analisar() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);
    const [timeOutDownloadMinutos, setTimeOutDownloadMinutos] = React.useState(0);

    useEffect(async () => {
        let ret = await sysparamFindBySysNome("TIMEOUT_DOWNLOAD_MINUTOS");
        setTimeOutDownloadMinutos(ret.data[0].sys_valor);
    }, []);

    var marcacao = [];
    var lista = 0;

    const Content = () => {
        const [statusScreen, setStatusScreen] = React.useState({
            disableDownloadFile: false,
            hiddenImage: true,
            disableButtonSave: true,
            disableButtonFinish: true,
        });
        const [containerDisponivel, setContainerDisponivel] = React.useState({});
        const [imageContainer, setImageContainer] = React.useState("");
        const [openDialog, setOpenDialog] = React.useState(false);
        const [openSnackBar, setOpenSnackBar] = React.useState(false);
        const [openLoading, setOpenLoading] = React.useState(false);

        const closeDialog = () => {
            setOpenDialog(false);

            if (marcacao.length > 0 && lista > 0) {
                finalizarAnalise();
            }

            if (marcacao.length > 0 && lista === 0) {
                msg =
                    "Você fez " +
                    marcacao.length +
                    " marcação(s), mas não inseriu nenhum item de descrição";
                severity = "error";
                setOpenSnackBar(true);
            }

            if (marcacao.length === 0 && lista > 0) {
                msg = "Você não fez marcações, mas inseriu item(s) de descrição";
                severity = "error";
                setOpenSnackBar(true);
            }
        };

        const openDialogImagem = async () => {
            setOpenSnackBar(false);
            setOpenDialog(true);
        };

        const uploadFile = async () => {
            let dataImg = canvas.toDataURL();
            const imagem = {
                trk_id: containerDisponivel.trk_id,
                veu_id: containerDisponivel.veu_id,
                img: dataImg,
            };

            try {
                await uploadSuspectImage(imagem);
                msg = "Upload concluido com sucesso";
                severity = "success";
                setOpenSnackBar(true);
                return true;
            } catch (error) {
                msg = "Upload concluido com falha, tente novamente";
                severity = "error";
                setOpenSnackBar(true);
                return false;
            }
        };

        const Imagem = (props) => {
            return (
                <img
                    id="imgcontainer"
                    name="imgcontainer"
                    {...props}
                    alt="Imagem do Container"
                />
            );
        };

        const Dialogo = () => {
            const [reloadDialog, setReloadDialog] = React.useState(0);

            const Canvas = (props) => {
                let context;
                let startPosition = {};
                let endPosition = {};
                let imgUURL = null;

                const canvasRef = useRef(null);
                var size = { width: "600", height: "359" };
                var rect = {};

                useEffect(async () => {
                    async function getImage() {
                        const ret1 = await containerLowresolution(
                            containerDisponivel.trk_id
                        );
                        imgUURL = URL.createObjectURL(ret1.data);
                    }

                    canvas = canvasRef.current;
                    context = canvas.getContext("2d");
                    rect = canvas.getBoundingClientRect();

                    if (containerDisponivel.trk_id) {
                        await getImage();
                        var imageObj1 = new Image();
                        imageObj1.src = imgUURL;
                        imageObj1.onload = function () {
                            context.drawImage(imageObj1, 0, 0);
                            size = { width: imageObj1.width, height: imageObj1.height };
                            let i = 0;
                            for (i = 0; i < marcacao.length; i++) {
                                context.strokeStyle = "#FF0000";
                                context.lineWidth = 3;
                                context.strokeRect(
                                    marcacao[i].x1,
                                    marcacao[i].y1,
                                    marcacao[i].x2,
                                    marcacao[i].y2
                                );
                            }
                            props.setMarcacao(marcacao.length);
                        };
                        canvas.addEventListener("mouseup", handleDocumentMouseUp);
                        canvas.addEventListener("mousedown", handleDocumentMouseDown);
                    }
                }, []);

                const handleDocumentMouseUp = (event) => {
                    if (event.button !== 2) {
                        endPosition = {
                            x: event.clientX - rect.left,
                            y: event.clientY - rect.top,
                        };
                        context.strokeStyle = "#FF0000";
                        context.lineWidth = 3;
                        context.strokeRect(
                            startPosition.x,
                            startPosition.y,
                            endPosition.x - startPosition.x,
                            endPosition.y - startPosition.y
                        );
                        marcacao.push({
                            x1: startPosition.x,
                            y1: startPosition.y,
                            x2: endPosition.x - startPosition.x,
                            y2: endPosition.y - startPosition.y,
                        });
                        props.setMarcacao(marcacao.length);
                    }
                };
                const handleDocumentMouseDown = (event) => {
                    if (event.button !== 2) {
                        startPosition = {
                            x: event.clientX - rect.left,
                            y: event.clientY - rect.top,
                        };
                    }
                };
                return (
                    <canvas
                        ref={canvasRef}
                        {...props}
                        width={size.width}
                        height={size.height}
                        style={{ border: "2px solid black" }}
                    />
                );
            }; //Fim do Canvas

            const EntradaDeDados = (props) => {
                const [listSuspeitaTipo, setListSuspeitaTipo] = React.useState([]);
                const [listSuspeita, setListSuspeita] = React.useState([]);
                const limparEntradas = async () => {
                    await suspeitaDelete({
                        con_id: containerDisponivel.con_id,
                        cov_id: containerDisponivel.cov_id,
                        veu_id: containerDisponivel.veu_id,
                    });

                    const respSuspeita = await suspeitaFindByConIdCovIdVeuId({
                        con_id: containerDisponivel.con_id,
                        cov_id: containerDisponivel.cov_id,
                        veu_id: containerDisponivel.veu_id,
                    });
                    setListSuspeita(respSuspeita.data);
                    lista = respSuspeita.data.length;
                };

                useEffect(async () => {
                    const respSuspeitaTipo = await suspeitaTipoFindAll();
                    const respSuspeita = await suspeitaFindByConIdCovIdVeuId({
                        con_id: containerDisponivel.con_id,
                        cov_id: containerDisponivel.cov_id,
                        veu_id: containerDisponivel.veu_id,
                    });
                    setListSuspeitaTipo(respSuspeitaTipo.data);
                    setListSuspeita(respSuspeita.data);
                }, [props.marcacao]);

                const limparImagem = () => {
                    setReloadDialog(reloadDialog + 1);
                    marcacao = [];
                };

                return (
                    <Formik
                        initialValues={{
                            sutId: "",
                            descricao: "",
                        }}
                        validate={(values) => {
                            const errors = {};
                            if (!values.sutId) {
                                errors.sutId = "Tipo Obrigatório";
                            } else if (!values.descricao) {
                                errors.descricao = "Descrição Obrigatório";
                            }
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting, resetForm }) => {
                            let respdt = await sysdatetime();
                            let dt = respdt.data;
                            console.log("Data", dt);

                            await suspeitaInsert({
                                con_id: containerDisponivel.con_id,
                                cov_id: containerDisponivel.cov_id,
                                veu_id: containerDisponivel.veu_id,
                                sut_id: values.sutId,
                                sus_data: dt.sysdatetime,
                                sus_descricao: values.descricao,
                            });

                            const respSuspeita = await suspeitaFindByConIdCovIdVeuId({
                                con_id: containerDisponivel.con_id,
                                cov_id: containerDisponivel.cov_id,
                                veu_id: containerDisponivel.veu_id,
                            });
                            setListSuspeita(respSuspeita.data);
                            lista = respSuspeita.data.length;
                            resetForm();
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            isValid,
                        }) => (
                            <form onSubmit={handleSubmit} className={classes.form}>
                                <div>
                                    {props.marcacao} / {listSuspeita.length}
                                </div>
                                <FormControl
                                    className={classes.formControl}
                                    style={{ width: "200px", marginTop: "10px" }}
                                >
                                    <InputLabel id="label-tipo">Tipo</InputLabel>
                                    <Select
                                        labelId="label-tipo"
                                        id="sutId"
                                        name="sutId"
                                        value={values.sutId}
                                        onChange={handleChange}
                                    >
                                        {listSuspeitaTipo.map((option) => (
                                            <MenuItem key={option.sut_id} value={option.sut_id}>
                                                {option.sut_id}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <TextField
                                    value={values.descricao}
                                    id="descricao"
                                    name="descricao"
                                    type="text"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={{
                                        width: "300px",
                                        marginTop: "10px",
                                        marginLeft: "10px",
                                    }}
                                    label="Descrição"
                                    helperText={errors.descricao}
                                />

                                <div className={classes.diagPranchetaBotoes}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        endIcon={<SaveIcon />}
                                        style={{ marginTop: "30px" }}
                                        type="submit"
                                        disabled={!isValid}
                                    >
                                        Salvar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        endIcon={<DeleteIcon />}
                                        style={{ marginTop: "30px" }}
                                        onClick={limparEntradas}
                                    >
                                        Limpar Entradas
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        endIcon={<RefreshIcon />}
                                        style={{ marginTop: "30px" }}
                                        onClick={limparImagem}
                                    >
                                        Limpar Imagem
                                    </Button>
                                </div>

                                <div className={classes.boxDataGrid}>
                                    <ThemeProvider theme={theme}>
                                        <DataGrid
                                            rows={listSuspeita}
                                            disableColumnMenu
                                            disableColumnReorder
                                            id="usu_id"
                                            rowHeight="25"
                                            columns={[
                                                {
                                                    field: "sut_id",
                                                    headerName: "Tipo",
                                                    headerClassName: "header_grid",
                                                    type: "string",
                                                    headerAlign: "center",
                                                    width: 150,
                                                    sortable: false,
                                                },
                                                {
                                                    field: "sus_descricao",
                                                    headerName: "Descrição",
                                                    headerClassName: "header_grid",
                                                    type: "string",
                                                    headerAlign: "center",
                                                    flex: 1,
                                                },
                                            ]}
                                        />
                                    </ThemeProvider>
                                </div>
                            </form>
                        )}
                    </Formik>
                );
            }; //Fim EntradaDeDados

            const EntradaDeDadosCanvas = () => {
                const [marcacao, setMarcacao] = React.useState(0);
                return (
                    <div className={classes.diagPrancheta}>
                        <div className={classes.diagPranchetaCanvas}>
                            <Canvas id="canvas" name="canvas" setMarcacao={setMarcacao} />
                        </div>
                        <div className={classes.diagPranchetaDados}>
                            <EntradaDeDados marcacao={marcacao} />
                        </div>
                    </div>
                );
            };

            return (
                <Dialog
                    open={openDialog}
                    aria-labelledby="form-dialog-title"
                    maxWidth="900px"
                >
                    <DialogTitle id="form-dialog-title">
                        Imagem Suspeita
                        <ButtonSave
                            variant="contained"
                            color="primary"
                            type="button"
                            onClick={closeDialog}
                        >
                            Fechar
                        </ButtonSave>
                        <Divider />
                    </DialogTitle>
                    <DialogContent>
                        <EntradaDeDadosCanvas />
                    </DialogContent>
                </Dialog>
            );
        };

        const setImagem = async () => {
            try {
                const ret1 = await containerLowresolution(containerDisponivel.trk_id);
                var blob = new Blob([ret1.data], { type: "image/jpeg" });
                var url = URL.createObjectURL(blob);
                setImageContainer(url);
            } catch (error) {
                console.log("Ocorreu um erro ", error);
                throw error("Problemas com o Download da Imagem");
            }
        };

        const downloadImg = async () => {
            setOpenSnackBar(false);
            setOpenLoading(true);

            let ret;

            try {
                if (authState.papel === "Supervisor") {
                    ret = await availableSupervisor({ usu_id: authState.id });
                } else {
                    ret = await availableOperador({ usu_id: authState.id });
                }

                if (process.env.REACT_APP_DEBUG_MODE === "True") {
                    console.log(ret);
                }

                if (ret.data.length > 0) {
                    let conId = ret.data[0].con_id;
                    try {
                        const ret2 = await containerImagehighresolution(ret.data[0].trk_id);
                        const retUsuarioNextSequence = await usuarioNextSequence(
                            authState.id
                        );
                        let file = retUsuarioNextSequence.data[0].usu_seq_download + ".Img";
                        var blob = new Blob([ret2.data], {
                            type: "application/octet-stream",
                        });

                        if (process.env.REACT_APP_DEBUG_MODE === "True") {
                            console.log("container id", conId, file);
                        }

                        download(blob, file);
                        setStatusScreen({
                            disableDownloadFile: true,
                            hiddenImage: true,
                            disableButtonSave: false,
                            disableButtonFinish: true,
                        });

                        if (process.env.REACT_APP_DEBUG_MODE === "True") {
                            console.log("Container Disponivel (setImagem)", ret.data[0]);
                        }

                        setContainerDisponivel(ret.data[0]);
                        setOpenLoading(false);
                    } catch (error) {
                        console.log(error);
                        severity = "error";
                        msg =
                            "Não consegui fazer o download da imagem. Verifique com suporte.";
                        setOpenSnackBar(true);
                        setOpenLoading(false);
                    }
                } else {
                    severity = "warning";
                    msg = "Nao há mais analises disponíveis";
                    setOpenSnackBar(true);
                    setOpenLoading(false);
                }
            } catch (error) { }
        };

        const finalizarAnalise = async () => {
            let ret = await checkifexpired({
                data_download: containerDisponivel.veu_data_download,
                timeout: timeOutDownloadMinutos,
            });
            let expired = ret.data.expired;
            let dif = ret.data.dif;
            if (expired) {
                setStatusScreen({
                    disableDownloadFile: false,
                    hiddenImage: true,
                    disableButtonSave: true,
                    disableButtonFinish: true,
                });
                msg =
                    "Tempo para conclusão da analise expirado. Você levou mais de " +
                    dif +
                    " minuto(s) e o tempo para conclusão é de " +
                    timeOutDownloadMinutos +
                    " minuito(s)";
                severity = "error";
                setOpenLoading(false);
                setOpenSnackBar(true);
                marcacao = [];
                lista = 0;
            } else if (marcacao.length > 0 && lista === 0) {
                msg =
                    "Você fez " +
                    marcacao.length +
                    " marcação(s), mas não inseriu nenhum item de descrição";
                severity = "error";
                setOpenSnackBar(true);
            } else if (marcacao.length === 0 && lista > 0) {
                msg = "Você não fez marcações, mas inseriu item(s) de descrição";
                severity = "error";
                setOpenSnackBar(true);
            } else {
                let respdt = await sysdatetime();
                let dt = respdt.data;

                setOpenLoading(true);
                let vereditoOperador;
                let situacaoVerificada;

                if (marcacao.length > 0) {
                    vereditoOperador = 1;
                    await uploadFile();
                } else {
                    vereditoOperador = 0;
                }
                if (containerDisponivel.pap_id === "Operador") {
                    //Operador Fez Marcacoes
                    situacaoVerificada = verificarSituacao(
                        containerDisponivel.pap_id,
                        parseInt(containerDisponivel.ver_id),
                        containerDisponivel.con_ai_analise,
                        undefined,
                        undefined,
                        vereditoOperador,
                        situacaoContainer
                    );

                    let msgcon =
                        "Apurado (Operador) (2): " +
                        " Tipo Operacao: " +
                        containerDisponivel.pap_id +
                        " Con ID: " +
                        containerDisponivel.con_id +
                        " Veu ID: " +
                        containerDisponivel.veu_id +
                        " Usu ID: " +
                        authState.id +
                        " Veredito Porto: " +
                        containerDisponivel.ver_id +
                        " Analise IA: " +
                        containerDisponivel.con_ai_analise +
                        " Situacao Container: " +
                        situacaoContainer +
                        " Veredito Operacao: " +
                        vereditoOperador +
                        " SituacaoVerificada: " +
                        situacaoVerificada;

                    await msgconsole({ msg: msgcon });
                } else {
                    let resp1 = await vereditosAtribuidos(containerDisponivel.con_id);
                    situacaoVerificada = verificarSituacao(
                        containerDisponivel.pap_id,
                        parseInt(resp1.data[0].ver_id_operador),
                        resp1.data[0].con_ai_analise,
                        parseInt(resp1.data[0].ver_id_usuario),
                        resp1.data[0].veu_usu_analise,
                        vereditoOperador,
                        situacaoContainer
                    );

                    let msgcon =
                        "Apurado (Supervisor) (2): " +
                        " Tipo Operacao: " +
                        containerDisponivel.pap_id +
                        " Con ID: " +
                        containerDisponivel.con_id +
                        " Veu ID: " +
                        containerDisponivel.veu_id +
                        " Usu ID: " +
                        authState.id +
                        " Veredito Porto: " +
                        containerDisponivel.ver_id +
                        " Analise IA: " +
                        containerDisponivel.con_ai_analise +
                        " Veredito Usuario: " +
                        resp1.data[0].ver_id_usuario +
                        " Analise Usuario: " +
                        resp1.data[0].veu_usu_analise +
                        " Situacao Container: " +
                        situacaoContainer +
                        " Veredito Operacao: " +
                        vereditoOperador +
                        " SituacaoVerificada: " +
                        situacaoVerificada;

                    await msgconsole({ msg: msgcon });
                }

                switch (situacaoVerificada) {
                    case "Inconsistente":
                        await updateVereditoInconsistente({
                            con_id: containerDisponivel.con_id,
                            cov_id: containerDisponivel.cov_id,
                            veu_id: containerDisponivel.veu_id,
                            veu_tipo: containerDisponivel.veu_tipo,
                            veu_usu_analise: situacaoContainer,
                            rea_id: containerDisponivel.rea_id,
                            rei_seq: containerDisponivel.rei_seq,
                            ver_id: vereditoOperador,
                            veu_data_conclusao: dt.sysdatetime,
                            usu_id: containerDisponivel.usu_id,
                            usu_id_conn: authState.id,
                        });
                        setStatusScreen({
                            disableDownloadFile: false,
                            hiddenImage: true,
                            disableButtonSave: true,
                            disableButtonFinish: true,
                        });
                        msg = "Analise concluída com sucesso";
                        severity = "success";
                        setOpenLoading(false);
                        setOpenSnackBar(true);
                        break;
                    case "Suspeito":
                        await updateVereditoSuspeito({
                            con_id: containerDisponivel.con_id,
                            cov_id: containerDisponivel.cov_id,
                            veu_id: containerDisponivel.veu_id,
                            ver_id: vereditoOperador,
                            veu_usu_analise: situacaoContainer,
                            rea_id: containerDisponivel.rea_id,
                            rei_seq: containerDisponivel.rei_seq,
                            veu_data_conclusao: dt.sysdatetime,
                            usu_id: containerDisponivel.usu_id,
                            usu_id_conn: authState.id,
                        });
                        setStatusScreen({
                            disableDownloadFile: false,
                            hiddenImage: true,
                            disableButtonSave: true,
                            disableButtonFinish: true,
                        });
                        msg = "Analise concluída com sucesso";
                        severity = "success";
                        setOpenLoading(false);
                        setOpenSnackBar(true);
                        break;
                    case "Aprovado":
                        await updateVereditoAprovado({
                            con_id: containerDisponivel.con_id,
                            cov_id: containerDisponivel.cov_id,
                            veu_id: containerDisponivel.veu_id,
                            ver_id: vereditoOperador,
                            veu_usu_analise: situacaoContainer,
                            rea_id: containerDisponivel.rea_id,
                            rei_seq: containerDisponivel.rei_seq,
                            veu_data_conclusao: dt.sysdatetime,
                            usu_id: containerDisponivel.usu_id,
                            usu_id_conn: authState.id,
                        });
                        setStatusScreen({
                            disableDownloadFile: false,
                            hiddenImage: true,
                            disableButtonSave: true,
                            disableButtonFinish: true,
                        });
                        msg = "Analise concluída com sucesso";
                        severity = "success";
                        setOpenLoading(false);
                        setOpenSnackBar(true);
                        break;
                    default:
                        let msgcon =
                            "Problemas na fase 1" +
                            " Con_ID:" +
                            containerDisponivel.con_id +
                            " Veu_ID: " +
                            containerDisponivel.veu_id +
                            " Usu ID: " +
                            authState.id +
                            " Ver_id: " +
                            containerDisponivel.ver_id +
                            " Veu_Usu_Analise: " +
                            situacaoContainer +
                            " Veu_data_conclusao: " +
                            dt.sysdatetime;
                        await msgconsole({ msg: msgcon }).then((result) => { });
                        console.log("Problemas na fase 1", containerDisponivel);
                        break;
                }

                setStatusScreen({
                    disableDownloadFile: false,
                    hiddenImage: true,
                    disableButtonSave: true,
                    disableButtonFinish: true,
                });
                msg = "Analise concluída com sucesso";
                severity = "success";
                setOpenLoading(false);
                setOpenSnackBar(true);
                marcacao = [];
                lista = 0;
            }
        };

        const verificarSituacao = (
            tipoOperacao,
            vereditoPorto,
            analiseAI,
            vereditoUsuario,
            analiseUsuario,
            vereditoOperador,
            analiseOperador
        ) => {
            if (tipoOperacao === "Operador") {
                if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Vazio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Inconsistente";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Vazio" &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (analiseOperador === "Vazio" && vereditoOperador === 0) {
                    return "Aprovado";
                } else {
                    let msgcon =
                        "Fase 1 Continuar (2):" +
                        " Con_ID: " +
                        containerDisponivel.con_id +
                        " Veu_ID: " +
                        containerDisponivel.veu_id +
                        " Usu ID: " +
                        authState.id +
                        " Veredito Porto: " +
                        vereditoPorto +
                        " Analise IA: " +
                        analiseAI +
                        " Analise Operador: " +
                        analiseOperador +
                        " Veredito Operador: " +
                        vereditoOperador +
                        " Situação Container: " +
                        situacaoContainer;

                    msgconsole({ msg: msgcon }).then((result) => { });

                    console.log(
                        "Fase 1 Continuar (2)",
                        tipoOperacao,
                        vereditoPorto,
                        analiseAI,
                        analiseOperador,
                        vereditoOperador
                    );
                    return "Continuar";
                }
            } else if (tipoOperacao === "Supervisor") {
                if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 1 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 1 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 1 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Vazio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";

                    // Adicionado 01/04/2022
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 1 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 1 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 1 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Suspeito";

                    //
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Vazio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 1
                ) {
                    return "Suspeito";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Cheio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (
                    vereditoPorto === 0 &&
                    analiseAI === "Vazio" &&
                    analiseUsuario === "Cheio" &&
                    vereditoUsuario === 0 &&
                    analiseOperador === "Cheio" &&
                    vereditoOperador === 0
                ) {
                    return "Aprovado";
                } else if (analiseOperador === "Vazio" && vereditoOperador === 0) {
                    return "Aprovado";
                } else {
                    let msgcon =
                        "Fase 2 Continuar (1)" +
                        " Con_ID: " +
                        containerDisponivel.con_id +
                        " Veu_ID: " +
                        containerDisponivel.veu_id +
                        " Usu ID: " +
                        authState.id +
                        " Veredito Porto: " +
                        vereditoPorto +
                        " Analise IA: " +
                        analiseAI +
                        " Analise Usuario: " +
                        analiseUsuario +
                        " Veredito Usuario: " +
                        vereditoUsuario +
                        " Analise Operador: " +
                        analiseOperador +
                        " Veredito Operador: " +
                        vereditoOperador +
                        " Situação Container: " +
                        situacaoContainer;

                    msgconsole({ msg: msgcon }).then((result) => { });
                    console.log(
                        "Fase 2 Continuar (1)",
                        tipoOperacao,
                        vereditoPorto,
                        analiseAI,
                        analiseUsuario,
                        vereditoUsuario,
                        analiseOperador,
                        vereditoOperador
                    );
                    return "Continuar";
                }
            }
        };

        return (
            <Fragment>
                <ShowMessageBox
                    open={openSnackBar}
                    setOpen={setOpenSnackBar}
                    severity={severity}
                    msg={msg}
                />
                <Dialogo containerDisponivel={containerDisponivel} />
                <Loading open={openLoading} />
                <div className={classes.box}>
                    <Formik
                        initialValues={{
                            cheio: false,
                        }}
                        validate={(values) => { }}
                        onSubmit={async (values, { setSubmitting, resetForm }) => {
                            setSubmitting(true);
                            setOpenLoading(true);
                            situacaoContainer = "Vazio";
                            if (values.cheio) {
                                situacaoContainer = "Cheio";
                            }
                            let situacaoVerificada;

                            let ret = await checkifexpired({
                                data_download: containerDisponivel.veu_data_download,
                                timeout: timeOutDownloadMinutos,
                            });
                            let expired = ret.data.expired;
                            let dif = ret.data.dif;
                            if (expired) {
                                setStatusScreen({
                                    disableDownloadFile: false,
                                    hiddenImage: true,
                                    disableButtonSave: true,
                                    disableButtonFinish: true,
                                });
                                msg =
                                    "Tempo para conclusão da analise expirado. Você levou mais de " +
                                    dif +
                                    " minuto(s) e o tempo para conclusão é de " +
                                    timeOutDownloadMinutos +
                                    " minuito(s)";
                                severity = "error";
                                setOpenLoading(false);
                                setOpenSnackBar(true);
                            } else {
                                let respdt = await sysdatetime();
                                let dt = respdt.data;

                                console.log("Data", dt);

                                if (containerDisponivel.pap_id === "Operador") {
                                    situacaoVerificada = verificarSituacao(
                                        containerDisponivel.pap_id,
                                        parseInt(containerDisponivel.ver_id),
                                        containerDisponivel.con_ai_analise,
                                        undefined,
                                        undefined,
                                        situacaoContainer === "Vazio" ? parseInt("0") : undefined,
                                        situacaoContainer
                                    );

                                    let msgcon =
                                        "Apurado (Operador) (1): " +
                                        " Tipo Operacao: " +
                                        containerDisponivel.pap_id +
                                        " Con ID: " +
                                        containerDisponivel.con_id +
                                        " Veu ID: " +
                                        containerDisponivel.veu_id +
                                        " Usu ID: " +
                                        authState.id +
                                        " Veredito Porto: " +
                                        containerDisponivel.ver_id +
                                        " Analise IA: " +
                                        containerDisponivel.con_ai_analise +
                                        " Situacao Container: " +
                                        situacaoContainer +
                                        " SituacaoVerificada: " +
                                        situacaoVerificada;

                                    await msgconsole({ msg: msgcon }).then((result) => { });
                                } else {
                                    let resp1 = await vereditosAtribuidos(
                                        containerDisponivel.con_id
                                    );
                                    situacaoVerificada = verificarSituacao(
                                        containerDisponivel.pap_id, //tipoOperacao
                                        parseInt(resp1.data[0].ver_id_operador), //vereditoPorto
                                        resp1.data[0].con_ai_analise, //analiseAI
                                        parseInt(resp1.data[0].ver_id_usuario), //vereditoUsuario
                                        resp1.data[0].veu_usu_analise, //analiseUsuario
                                        situacaoContainer === "Vazio" ? parseInt("0") : undefined, //vereditoOperador
                                        situacaoContainer
                                    ); //analiseOperador;

                                    let msgcon =
                                        "Apurado (Supervisor) (1): " +
                                        " Tipo Operacao: " +
                                        containerDisponivel.pap_id +
                                        " Con ID: " +
                                        containerDisponivel.con_id +
                                        " Veu ID: " +
                                        containerDisponivel.veu_id +
                                        " Usu ID: " +
                                        authState.id +
                                        " Veredito Porto: " +
                                        containerDisponivel.ver_id +
                                        " Analise IA: " +
                                        containerDisponivel.con_ai_analise +
                                        " Veredito Usuario: " +
                                        resp1.data[0].ver_id_usuario +
                                        " Analise Usuario: " +
                                        resp1.data[0].veu_usu_analise +
                                        " Situacao Container: " +
                                        situacaoContainer +
                                        " SituacaoVerificada: " +
                                        situacaoVerificada;

                                    await msgconsole({ msg: msgcon }).then((result) => { });
                                }

                                if (process.env.REACT_APP_DEBUG_MODE === "True") {
                                    console.log("Container Disponível", containerDisponivel);
                                    console.log("Situacao Verificada", situacaoContainer);
                                    console.log("Situacao Container", situacaoContainer);
                                }

                                if (
                                    situacaoContainer === "Cheio" &&
                                    situacaoVerificada !== "Inconsistente"
                                ) {
                                    setStatusScreen({
                                        disableDownloadFile: true,
                                        hiddenImage: false,
                                        disableButtonSave: true,
                                        disableButtonFinish: false,
                                    });
                                    try {
                                        await setImagem();
                                        setSubmitting(false);
                                        setOpenLoading(false);
                                    } catch (error) {
                                        msg = "Falha ao fazer o download do Stamp";
                                        severity = "error";
                                        setOpenSnackBar(true);
                                        setOpenLoading(false);
                                    }
                                    return;
                                }

                                switch (situacaoVerificada) {
                                    case "Inconsistente":
                                        await updateVereditoInconsistente({
                                            con_id: containerDisponivel.con_id,
                                            cov_id: containerDisponivel.cov_id,
                                            veu_id: containerDisponivel.veu_id,
                                            veu_tipo: containerDisponivel.veu_tipo,
                                            veu_usu_analise: situacaoContainer,
                                            rea_id: containerDisponivel.rea_id,
                                            rei_seq: containerDisponivel.rei_seq,
                                            ver_id: "0",
                                            veu_data_conclusao: dt.sysdatetime,
                                            usu_id: containerDisponivel.usu_id,
                                            usu_id_conn: authState.id,
                                        });
                                        setStatusScreen({
                                            disableDownloadFile: false,
                                            hiddenImage: true,
                                            disableButtonSave: true,
                                            disableButtonFinish: true,
                                        });
                                        setSubmitting(false);
                                        msg = "Analise concluída com sucesso";
                                        severity = "success";
                                        setOpenLoading(false);
                                        setOpenSnackBar(true);
                                        break;

                                    case "Suspeito":
                                        await updateVereditoSuspeito({
                                            con_id: containerDisponivel.con_id,
                                            cov_id: containerDisponivel.cov_id,
                                            veu_id: containerDisponivel.veu_id,
                                            ver_id: "0",
                                            veu_usu_analise: situacaoContainer,
                                            rea_id: containerDisponivel.rea_id,
                                            rei_seq: containerDisponivel.rei_seq,
                                            veu_data_conclusao: dt.sysdatetime,
                                            usu_id: containerDisponivel.usu_id,
                                            usu_id_conn: authState.id,
                                        });
                                        setStatusScreen({
                                            disableDownloadFile: false,
                                            hiddenImage: true,
                                            disableButtonSave: true,
                                            disableButtonFinish: true,
                                        });
                                        setSubmitting(false);
                                        msg = "Analise concluída com sucesso";
                                        severity = "success";
                                        setOpenLoading(false);
                                        setOpenSnackBar(true);
                                        break;
                                    case "Aprovado":
                                        await updateVereditoAprovado({
                                            con_id: containerDisponivel.con_id,
                                            cov_id: containerDisponivel.cov_id,
                                            veu_id: containerDisponivel.veu_id,
                                            ver_id: 0,
                                            veu_usu_analise: situacaoContainer,
                                            rea_id: containerDisponivel.rea_id,
                                            rei_seq: containerDisponivel.rei_seq,
                                            veu_data_conclusao: dt.sysdatetime,
                                            usu_id: containerDisponivel.usu_id,
                                            usu_id_conn: authState.id,
                                        });
                                        setStatusScreen({
                                            disableDownloadFile: false,
                                            hiddenImage: true,
                                            disableButtonSave: true,
                                            disableButtonFinish: true,
                                        });
                                        setSubmitting(false);
                                        msg = "Analise concluída com sucesso";
                                        severity = "success";
                                        setOpenLoading(false);
                                        setOpenSnackBar(true);
                                        break;
                                    case "Continuar":
                                        setStatusScreen({
                                            disableDownloadFile: true,
                                            hiddenImage: false,
                                            disableButtonSave: true,
                                            disableButtonFinish: false,
                                        });
                                        try {
                                            await setImagem();
                                            setSubmitting(false);
                                            setOpenLoading(false);
                                        } catch (error) {
                                            msg = "Falha ao fazer o download do Stamp";
                                            severity = "error";
                                            setOpenSnackBar(true);
                                            setOpenLoading(false);
                                        }
                                        break;
                                    default:
                                        let msgcon =
                                            "Problemas na faze 1 (3): " +
                                            " Tipo Operacao: " +
                                            containerDisponivel.pap_id +
                                            " Con ID: " +
                                            containerDisponivel.con_id +
                                            " Veu ID: " +
                                            containerDisponivel.veu_id +
                                            " Usu ID: " +
                                            authState.id +
                                            " Veredito Porto: " +
                                            containerDisponivel.ver_id +
                                            " Analise IA: " +
                                            containerDisponivel.con_ai_analise +
                                            " Situacao Container: " +
                                            situacaoContainer +
                                            " SituacaoVerificada: " +
                                            situacaoVerificada;

                                        await msgconsole({ msg: msgcon }).then((result) => { });

                                        console.log("Problemas na faze 1 (3)", containerDisponivel);
                                        break;
                                }
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            isValid,
                        }) => (
                            <form onSubmit={handleSubmit} className={classes.form}>
                                <Paper className={classes.boxPrancheta} elevation={7}>
                                    <div className={classes.box_analise}>
                                        <div className={classes.box_analise_cabecalho}>
                                            <div className={classes.button_download}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    component="span"
                                                    endIcon={<CloudDownloadIcon />}
                                                    onClick={downloadImg}
                                                    disabled
                                                >
                                                    Baixar Imagem
                                                </Button>
                                                <span
                                                    style={{
                                                        fontSize: "25px",
                                                        color: "white",
                                                        marginLeft: "20px",
                                                    }}
                                                >
                                                    Função desativada. Favor utilizar cliente Windows.
                                                </span>
                                            </div>
                                        </div>

                                        <div className={classes.box_analise_conteudo}>
                                            <span
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    margin: "10px",
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={values.cheio}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            disabled={statusScreen.disableButtonSave}
                                                            name="cheio"
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Cheio"
                                                />

                                                <span style={{ margin: "30px" }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        endIcon={<SaveIcon />}
                                                        type="submit"
                                                        disabled={statusScreen.disableButtonSave}
                                                    >
                                                        Salvar
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        endIcon={<DoneAll />}
                                                        style={{ marginLeft: "10px" }}
                                                        onClick={finalizarAnalise}
                                                        disabled={statusScreen.disableButtonFinish}
                                                        type="reset"
                                                    >
                                                        Finalizar
                                                    </Button>
                                                </span>
                                            </span>
                                        </div>

                                        <div>
                                            {!statusScreen.hiddenImage ? (
                                                <Imagem
                                                    src={imageContainer}
                                                    onClick={openDialogImagem}
                                                    className={classes.imagem}
                                                />
                                            ) : null}
                                        </div>
                                    </div>
                                </Paper>
                            </form>
                        )}
                    </Formik>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina authState={authState} Content={Content} HeaderDesc="ANALISAR" />
        </Fragment>
    );
}
